import axios, { AxiosHeaders, AxiosInstance, AxiosRequestConfig, RawAxiosRequestHeaders } from 'axios';

declare module 'axios' {
  export interface InternalAxiosRequestConfig {
    skipAuthInterceptor?: boolean;
  }

  export interface AxiosRequestConfig {
    skipAuthInterceptor?: boolean;
  }
}

import config from '../../config.ts';

import { bearerTokenInterceptor } from './interceptors/bearerToken.interceptor.ts';
import { onError, onSuccess } from './interceptors/response.interceptor.ts';
import { userLangHeaderInterceptor } from './interceptors/userLangHeader.interceptor.ts';

class AxiosConfig {
  private _baseUrl = config.API_URL;
  private _headerConfigs?: RawAxiosRequestHeaders | AxiosHeaders;
  private _configs: AxiosRequestConfig = {
    baseURL: this._baseUrl,
    timeout: 60000,
    headers: this._headerConfigs,
  };
  private _instance?: AxiosInstance;

  public get headerConfigs() {
    return this._headerConfigs;
  }

  public set headerConfigs(hConfigs) {
    this._headerConfigs = hConfigs;
  }

  public get axiosInstance() {
    return this._instance;
  }

  constructor(headers?: RawAxiosRequestHeaders | AxiosHeaders) {
    this._instance = axios.create(this._configs);
    this._headerConfigs = Object.assign({}, this._configs.headers, headers);

    this._instance?.interceptors.request.use(userLangHeaderInterceptor);

    this._instance?.interceptors.request.use(bearerTokenInterceptor);

    this._instance?.interceptors.response.use(onSuccess, onError);
  }
}

export default AxiosConfig;
